import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'works',
            name: 'work',
            class: 'Modules\\Site\\Entities\\Work'
        }
    }
}